export enum FlowUserRole {
  ContractHolder = 'contractHolder',
  GiftPurchaser = 'giftPurchaser',
  Partner = 'partner',
  Purchaser = 'purchaser',
  Solo = 'solo',
}
